import React from 'react';
import { useSelector } from 'react-redux';

import { getHome } from 'core/selectors';

import { Partners } from './Partners';

export const Container = () => {
  const { partners } = useSelector(getHome);

  if (!partners.length) {
    return null;
  }

  return <Partners data={partners} />;
};
